import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import Table from "../../../../../../components/Table";
import BaseListPage from "../../../../../../base/BaseListPage";
import Presenter from "../../../../../ReferenceTable/schedule-template/schedule/shdedule-form/schedule-page/Presenter";
import SearchSelect from "../../../../../../components/searchSelect/SearchSelect";
import AdditionalTalbePresenter from "../../additional-info/AdditionalTalbePresenter";
import InputFactory from "../../../../../../components/InputFactory";
import { dialog, Button } from "nq-component";
import AllowanceBeniFormPage from "./allowance-form/AllowanceBeniFormPage";
import {
  DialogConfirmation,
  extractSalary,
} from "../../../../../../components/common/Converter";

export default class AllowanceAndBeni extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AdditionalTalbePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );

    this.state = {
      allowance: [],
      selectedAllowance: "",
      selectedTax: "",
      object: [],
      initialData: [],
      amount: "",
      startDate: "",
      objectID: "",
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
      isModalOpen: false,
      isMonthlyRate: false,
      isAmount: false,
      excessAmount: 0,
      allowanceData: "",
    };
  }

  getCurrent() {
    return this.props.object.email;
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const leave = await findObjectUseCase().execute("allowance_type");
    const newObject = await findObjectUseCase().execute("allowances", {
      where: { empID: this.props.object.id },
    });
    this.setState({
      initialData: newObject,
      allowance: leave,
    });
  }

  getCollectionName() {
    return "allowances";
  }

  async handleDeleteData(data) {
    // await this.presenter.deleteObjectUseCase.execute("allowances", id);
    // await this.refetchData();
    DialogConfirmation(data.id, "allowances", () => this.refetchData(), true);
  }

  dialogClose() {
    dialog.close();
  }

  handleObjectData(data) {
    this.setState({
      isModalOpen: true,
      allowanceData: data,
    });
  }

  closeModal() {
    this.setState({ isModalOpen: false });
  }

  async hanldeAllowanceChange(selectedAllowance) {
    this.setState({ selectedAllowance });
  }

  onAmountChange(amount) {
    this.setState({ amount });
  }
  hanldeTaxChange(selectedTax) {
    this.setState({ selectedTax });
  }
  onStartDateChange(startDate) {
    this.setState({ startDate });
  }

  onchangeExcess(excessAmount) {
    this.setState({ excessAmount });
  }

  handleCheckBox(field) {
    this.setState((prevState) => {
      const newState = {
        isMonthlyRate:
          field === "isMonthlyRate" ? !prevState.isMonthlyRate : false,
        isAmount: field === "isAmount" ? !prevState.isAmount : false,
      };

      this.setState({
        amount: newState.isMonthlyRate ? "" : this.state.amount,
      });

      return newState;
    });
  }

  async handleSaveOnClick() {
    const object = this.props.object;

    // if (this.state.isMonthlyRate) {
    //   const salary = extractSalary(object?.salaryGrade);
    //   this.setState
    // }

    console.log("object", object);
    const data = {
      empID: this.props.object.id,
      email: this.props.object.email,
      allowance: this.state.selectedAllowance,
      amount: this.state.isMonthlyRate
        ? extractSalary(object?.salaryGrade)
        : this.state.amount,
      taxable: this.state.isMonthlyRate ? "YES" : this.state.selectedTax,
      excessAmount: this.state.isMonthlyRate
        ? extractSalary(object?.salaryGrade)
        : this.state.excessAmount,
      isMonthlyRate: this.state.isMonthlyRate,
      isAmount: this.state.isAmount,
    };
    const hasAllowance = await findObjectUseCase().execute(
      this.getCollectionName(),
      { where: { empID: data.empID, allowance: data.allowance } }
    );
    if (hasAllowance.length > 0) {
      this.showError("You cannot add same allowance type.");
    } else {
      if (this.state.objectID !== "") {
        const updateObject = { ...data, empID: this.state.objectID };
        await upsertUseCase().execute("allowances", updateObject);
        this.refetchData();
      } else {
        await upsertUseCase().execute("allowances", data);
        this.showSuccess("Data Successfully Added");
        await this.refetchData();
      }
      this.setState({
        selectedAllowance: "",
        amount: "",
        selectedTax: "",
        objectID: "",
        excessAmount: "",
        isMonthlyRate: false,
        isAmount: false,
      });
    }
  }

  async refetchData() {
    const newObject = await findObjectUseCase().execute("allowances", {
      where: { empID: this.props.object.id },
    });
    this.setState({ initialData: newObject });
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { allowance, objects, loading, count, current, limit } = this.state;
    const { object, isViewMode } = this.props;

    const tax = ["YES", "NO"];

    return (
      <>
        <div className="m-4">
          {!isViewMode && (
          <div className="row">
            <div className="col-lg-3 p-1 mb-2" style={{}}>
              <SearchSelect
                value={this.state.selectedAllowance}
                onClickClear={() => {
                  this.hanldeAllowanceChange("");
                }}
                onChange={this.hanldeAllowanceChange.bind(this)}
                options={allowance.map((allowance) => ({
                  label: allowance.AllowanceType,
                  value: allowance.AllowanceType,
                }))}
              />
            </div>
            <div className="col-lg-3">
              <div className="d-flex gap-2 align-items-center justify-content-center ">
                <label
                  style={{ display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <input
                    style={{ accentColor: "#0038A8" }}
                    type="checkbox"
                    onChange={() => this.handleCheckBox("isMonthlyRate")}
                    checked={this.state.isMonthlyRate}
                    name="isMonthlyRate"
                  />
                  <span>Monthly_rate</span>
                </label>

                <label
                  style={{ display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <input
                    style={{ accentColor: "#0038A8" }}
                    type="checkbox"
                    onChange={() => this.handleCheckBox("isAmount")}
                    checked={this.state.isAmount}
                    name="isAmount"
                  />
                  <span>Amount</span>
                </label>
              </div>
            </div>
            {this.state.isAmount && (
              <div className="col-lg-3 p-1 mb-2" style={{}}>
                <InputFactory
                  type="Number"
                  // _type="parseNumber"
                  placeholder="Enter Amount"
                  field={"amount"}
                  value={this.state.amount}
                  onChange={this.onAmountChange.bind(this)}
                />
              </div>
            )}
            {this.state.isAmount && (
              <div className="col-lg-3 p-1 mb-2" style={{}}>
                <SearchSelect
                  value={this.state.selectedTax}
                  onClickClear={() => {
                    this.hanldeTaxChange("");
                  }}
                  onChange={this.hanldeTaxChange.bind(this)}
                  options={tax.map((type) => ({
                    label: type,
                    value: type,
                  }))}
                  placeholder="Maximum-Non Taxable"
                />
              </div>
            )}

            {this.state.selectedTax === "YES" && (
              <div className="col-lg-3 p-1 mb-2">
                <InputFactory
                  type="Number"
                  field="excessAmount"
                  placeholder="Enter Amount"
                  value={this.state.excessAmount || ""}
                  onChange={(value) => this.onchangeExcess(value)}
                />
              </div>
            )}

            <div className="col-lg-3 p-1">
              <button
                onClick={this.handleSaveOnClick.bind(this)}
                type="button"
                className="btn btn-primary fs-sm me-3"
                disabled={!this.state.selectedAllowance}
              >
                Save
              </button>
            </div>
          </div>
          )}

          <Table
            objectId={!isViewMode ? this.handleDeleteData.bind(this) : undefined}
            refetch={this.refetchData.bind(this)}
            objectData={!isViewMode ? this.handleObjectData.bind(this) : undefined}
            progress={loading}
            fields={schema.fields}
            objects={this.state.initialData}
            collection={schema}
            count={count}
            limit={limit}
            current={current}
            loadPagination={this.onClickPagination.bind(this)}
            {...(!isViewMode && {
              actionsList: [
                {
                  label: <i class="bi bi-pencil-square" />,
                  actionType: "object",
                },
                {
                  label: <i className="bi bi-trash" />,
                  actionType: "delete",
                },
              ],
            })}
            excludeFields={Object.keys(schema.fields).reduce(
              (acc, key) => {
                const options = schema.fields[key];
                if (options.read === false) {
                  acc.push(key);
                }
                switch (options._type || options.type) {
                  case "Relation":
                  case "Array":
                  case "Object":
                  case "File":
                    acc.push(key);
                    break;
                  default:
                }
                return acc;
              },
              ["Id", "Created At", "Updated At", "name"]
            )}
            onClickItem={this.onClickItem.bind(this)}
          />
        </div>
        {!isViewMode && this.state.isModalOpen && (
          <AllowanceBeniFormPage
            allowance={allowance}
            closeModal={this.closeModal.bind(this)}
            data={this.state.allowanceData}
            refetchData={this.refetchData.bind(this)}
          />
        )}
      </>
    );
  }
}
